<template>
  <table class="table-hover reports-table budgets-report-table table">
    <tbody class="thead">
      <tr>
        <template v-if="walker.sub_show">
          <th>{{ walker.sub_label }}</th>
        </template>
        <th>Spent</th>
        <th>Budget</th>
        <th>Remaining</th>
      </tr>
    </tbody>
    <!-- eslint-disable vue/require-v-for-key -->
    <template v-for="section in tableData.sections">
      <tbody class="grouping-header">
        <tr>
          <th>
            <template v-if="walker.main_type === 'date'">
              {{ format_date_label(section.main) }}
            </template>
            <template v-else>
              <ReportTableAvatarInitial :text="section.main" />
              {{ section.main }}
            </template>
          </th>
          <th
            v-for="col in colCount - 1"
            :key="col"
          />
        </tr>
      </tbody>
      <tbody class="tbody">
        <tr
          v-for="row in section.rows"
          :class="row_class(row.sub_show_data)"
        >
          <template v-if="walker.sub_show">
            <td v-if="row.sub_show_data">
              <template v-if="walker.sub_type === 'date'">
                {{ format_date_label(row.record.sub) }}
              </template>
              <template v-else>
                <ReportTableAvatarInitial
                  :text="row.record.sub"
                  class-modifier="avatar"
                />
                {{ row.record.sub }}
              </template>
            </td>
            <td v-else />
          </template>
          <td>{{ budgetFormatter(row.record.budget_spent, row.record.budget_type, organization.currency) }}</td>
          <td>
            {{ budgetFormatter(row.record.budget_amount || 0, row.record.budget_type, organization.currency) }}
            <div class="progress-time-text">
              <ReportTableProgressBar
                :tracked="row.record.budget_spent"
                :total="row.record.budget_amount || 0"
                class="widget-progress"
              />
            </div>
            <span class="budget-percent">
              {{ row.record.budget_spent | percentage(row.record.budget_amount || 0, 0) }}
            </span>
          </td>
          <td>
            {{
              budgetFormatter(
                (row.record.budget_amount || 0) - row.record.budget_spent,
                row.record.budget_type,
                organization.currency,
                true,
              )
            }}
          </td>
        </tr>
      </tbody>
    </template>
    <!-- eslint-enable vue/require-v-for-key -->
  </table>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { formatDuration } from '~/utils/time_utils';
import { BUDGET_TYPE_COST } from '~/app_constants';

export default {
  name: 'BudgetsReportTable',
  props: {
    tableData: Object,
  },
  computed: {
    baseColCount() {
      return this.walker.base_column_count;
    },
    colCount() {
      let colCount = this.baseColCount;

      if (this.walker.sub_show) {
        colCount += 1;
      }

      return colCount;
    },
    ...mapGetters(['walker']),
    ...mapState(['organization']),
  },
  methods: {
    row_class: function (new_record) {
      return new_record ? 'has-border' : '';
    },
    format_date_label(value) {
      return value ? TimeUtils.parse_internal_date(value).format('MMMM, YYYY') : 'Fixed';
    },
    budgetFormatter: function (value, type, currency, durationDifference = false) {
      if (type === BUDGET_TYPE_COST) {
        return this.$options.filters.currency(value, currency);
      }

      return formatDuration(value, { roundSeconds: true, durationDifference });
    },
  },
};
</script>
